"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectedClientId = exports.setSelectedClientId = exports.getSelectedClientName = exports.setSelectedClientName = void 0;
var setSelectedClientName = function (clientName) {
    try {
        sessionStorage.setItem('selectedClientName', clientName);
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.setSelectedClientName = setSelectedClientName;
var getSelectedClientName = function () {
    var selectedClientName = sessionStorage.getItem('selectedClientName');
    if (selectedClientName) {
        return selectedClientName;
    }
    console.error('No Selected Client Name');
    return '';
};
exports.getSelectedClientName = getSelectedClientName;
var setSelectedClientId = function (clientId) {
    try {
        sessionStorage.setItem('selectedClientId', clientId.toString());
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.setSelectedClientId = setSelectedClientId;
var getSelectedClientId = function () {
    var selectedClientId = sessionStorage.getItem('selectedClientId');
    if (selectedClientId) {
        return parseInt(selectedClientId);
    }
    console.error('No Selected Client Id');
    return 0;
};
exports.getSelectedClientId = getSelectedClientId;
//# sourceMappingURL=clientSession.js.map